import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useNavigate,
  useParams
} from 'react-router-dom';
import { Button, Box, Stack, Typography, useTheme } from '@mui/material';
import Modal from 'components/Modal';

import {Header} from 'components/Modal';
import Spare from './Spare';
import NewDevice from './NewDevice';


export const Resume = ({kind = 'tv'}) => {
  const [waiting, setWaiting] = useState(false);
  const { deviceId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleConfirm = () => {
    setWaiting(true);
    setTimeout(() => navigate(`../${deviceId}/setup`), 5000);
  }
  return (
    <Modal
      minWidth="460px"
      onClose={() => navigate('..')}
    >
      <Stack sx={{ position: 'relative', height: '100%' }}>
        <Stack gap={2} sx={{ height: '100%' }}>
          <Header
            icon={<i className="fa-solid fa-check" />}
            title={kind === 'tv' ? t('stream-cast.actions.resume_title') : t('stream-cast.actions.resume_chromecast_title')}
          />
          <Stack sx={{ height: '100%' }} justifyContent="space-between">
            <Typography
              component="span"
              sx={{ fontSize: 14, textAlign: 'center' }}
              dangerouslySetInnerHTML={{ __html: kind === 'tv' ? t('stream-cast.actions.resume_description') : t('stream-cast.actions.resume_chromecast_description')}}
            />
            <Stack direction="row" justifyContent="space-between" mt={2}>
              <Button variant="outlined" onClick={() => navigate('..')}>
                {t('stream-cast.actions.resume_configuration_later')}
              </Button>
              <Button variant="contained" color="primary" onClick={handleConfirm} disabled={waiting}>
                {t('stream-cast.actions.resume_configuration_now')}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  )
}

const ModeItem = ({ icon, title, description, onClick }) => {
  const theme = useTheme();
  
  return (
    <Stack
      onClick={onClick}
      alignItems="center"
      gap={2}
      sx={{
        cursor: 'pointer',
        border: `${theme.palette.grey[200]} 1px solid`,
        borderRadius: 8,
        padding: 4,
        flexGrow: 1
      }}>
        <Box sx={{ color: 'primary.main', fontSize: 24, fontWeight: 800 }}>
          {icon}
        </Box>
        <Typography component="span" sx={{ fontSize: 12 }}>{title}</Typography>
        <Typography component="span" sx={{ fontSize: 10 }}>{description}</Typography>
    </Stack>

  )
}

const Home = ({ onSelect }) => {
  const { t } = useTranslation();
  return (
    <Stack gap={2} sx={{ height: '100%' }}>
      <Header icon={<i className="fa-regular fa-arrow-left-arrow-right" />} title={t('stream-cast.actions.replace_tv.title')} />
      <Typography component="span" sx={{ fontSize: 12, alignSelf: 'center', textAlign: 'center' }}>{t('stream-cast.actions.replace_tv.description')}</Typography>
      <Stack sx={{ height: '100%' }} justifyContent={'center'}>
        <Stack direction="row" gap={2} justifyContent="space-around" >
          <ModeItem 
            icon={<i className="fa-regular fa-box-arrow-down-arrow-up" style={{ fontSize: 24 }} />}
            title={t('stream-cast.actions.replace_spare.title')}
            description={t('stream-cast.actions.replace_spare.subtitle')}
            onClick={() => onSelect('spare')}
          />
          <ModeItem
            icon={<i className="fa-regular fa-box-taped" style={{ fontSize: 24 }} />}
            title={t('stream-cast.actions.replace_device.title')}
            description={t('stream-cast.actions.replace_device.subtitle')}
            onClick={() => onSelect('device')}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}

export const ReplaceChromecastModal = () => {
  const navigate = useNavigate();
  return (
    <Modal
      onClose={() => navigate('..')}
      minWidth="460px"
      height={'400px'}
    >
      <Stack sx={{ position: 'relative', height: '100%' }}>
        <Spare 
          kind={'chromecast'}
          onCancel={() => navigate('..')}
          onSuccess={(uuid) => navigate(`../${uuid}/replace_chromecast_resume`)} 
        />
      </Stack>
    </Modal>
  )
}
const ReplaceTvModal = () => {
  const [step, setStep] = useState('home');
  const navigate = useNavigate();

  return (
    <Modal onClose={() => navigate('..')} minWidth="460px" height={step === 'spare' ? '400px' : 'auto'}>
      <Stack sx={{ position: 'relative', height: '100%' }}>
        {step === 'home' && <Home onSelect={mode => setStep(mode)} />}
        {step === 'spare' && (
          <Spare
            kind={'tv'}
            onCancel={() => setStep('home')}
            onSuccess={uuid => navigate(`../${uuid}/replace_tv_resume`)}
          />
        )}
        {step === 'device' && (
          <NewDevice onCancel={() => setStep('home')} onSuccess={uuid => navigate(`../${uuid}/replace_tv_resume`)} />
        )}
      </Stack>
    </Modal>
  )
};

export default ReplaceTvModal;
